import { withPrefix } from "gatsby";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  withPrefix,
  ToolkitTopic,
  React
};